import { render, staticRenderFns } from "./OssInfo.vue?vue&type=template&id=b7d98a66&scoped=true&"
import script from "./OssInfo.vue?vue&type=script&lang=js&"
export * from "./OssInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7d98a66",
  null
  
)

export default component.exports